import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';

export const ClickAnimation: React.FC = ({ children }) => {
	const [state, toggle] = useState(true);

	const { x } = useSpring({
		from: { x: 0 },
		x: state ? 1 : 0,
		config: { duration: 200 },
	});

	return (
		<>
			<div onClick={() => toggle(!state)}>
				<animated.div
					style={{
						scale: x.to({
							range: [0, 0.25, 0.35, 0.5, 0.65, 1],
							output: [1, 0.99, 0.97, 0.94, 0.97, 1],
						}),
					}}
				>
					{children}
				</animated.div>
			</div>
		</>
	);
};

export default ClickAnimation;
